<template>
  <div>
    <div class="map-page" id="chart-map-pre">
    </div>
    <div class="map-btn">
      <a class="btn-1" href="javascript:;" @click="changeColor">显示地名</a><br>
      <a class="btn-3" href="javascript:;" @click="initBMap">&nbsp;初&nbsp;始&nbsp;化&nbsp;</a>
    </div>
    <div class="map-select-station" v-if="preStatus > 0">
      <el-select v-model="activeStation" placeholder="选择油库">
        <el-option v-for="item in stationLocationList" :key="item" :label="item" :value="item">
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
  window.echarts = require('echarts')

  window.myPreChat = null

  export default {
    data () {
      return {
        loadJs: false,
        first: '0'
      }
    },
    created () {
      this.$store.dispatch('setChatPreStatus', 0)
    },
    mounted () {
      window.initMap = this.initChar
      let chat = window.echarts.init(document.getElementById('chart-map-pre'))
      window.myPreChat = chat
      this.$store.dispatch('setChatPreStatus', 1)
      this.loadBdmapApi()
    },
    computed: {
      activeStation: {
        get () {
          return this.$store.getters.activeStation
        },
        set (value) {
          this.$store.dispatch('setActiveStation', value)
        }
      },
      preStatus: {
        get () {
          return this.$store.getters.preStatus
        }
      },
      stationLocationList: {
        get () {
          return ['云南昆东油库', '云南长坡油库', '云南中油安宁油库']
        }
      },
      mapOption: {
        get () {
          return this.$store.getters.mapOption
        }
      }
    },
    methods: {
      changeColor () {
        let option = window.myPreChat.getOption()
        let color = option.bmap[0].mapStyle.styleJson[14].color
        if (color === '#081734') {
          option.bmap[0].mapStyle.styleJson[14].color = '#FFFFFF'
          window.myPreChat.setOption(option)
        } else {
          option.bmap[0].mapStyle.styleJson[14].color = '#081734'
          window.myPreChat.setOption(option)
        }
      },
      loadBdmapApi () {
        this.loadJs = true
        let script = document.createElement('script')
        script.src = 'http://api.map.baidu.com/api?v=2.0&ak=O8eyfQgNIOYnnGYqM2xVAqXtmqkyk6CT&callback=initMap'
        document.body.appendChild(script)
      },
      initChar () {
        this.$store.dispatch('initMapPreOption')
      },
      initBMap () {
        let option = window.myPreChat.getOption()
        option.bmap[0].center = this.mapOption.center
        option.bmap[0].zoom = this.mapOption.zoom
        window.myPreChat.setOption(option, true)
      }
    }
  }
</script>
<style lang="less">
  .anchorBL {
    display: none;
  }
  .map-select-station .el-input__inner{
    text-align: center;
    background-color: #f8ac59;
    color:#fff;
    height: 20px;
    font-size: 10px;
    border:  1px solid #f8ac59;
  }
  .map-select-station .el-input.is-disabled .el-input__inner {
    background-color: #f8ac59;
    border:  1px solid #f8ac59;
    color:#fff;
  }
  .map-select-station .el-select .el-input__inner:focus {
    border-color: #f8ac59;
  }
  .map-select-station .el-select .el-input.is-disabled .el-input__inner:focus {
    border-color: #f8ac59;
  }
  .map-select-station .el-select:hover .el-input__inner {
    border-color: #f8ac59;
  }
  .map-select-station .el-select:hover .el-input.is-disabled .el-input__inner {
    border-color: #f8ac59;
  }
  .map-select-station input::-webkit-input-placeholder {
    color: #eee;
  }

</style>
<style scoped lang="less">
  @import '../style/base.less';
  .map-page {
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .map-select-station {
    position: absolute;
    bottom: 25px;
    right: 225px;
    z-index: 1000;
    width: 130px;
  }
  .map-btn {
    text-align: center;
    position: absolute;
    bottom: 20px;
    right: 120px;
    z-index: 1000;
    font-size: 14px;
    line-height: 2.3;
    a {
      color:#fff;
      border-radius: 0.2em;
      font-size: 0.7em;
      padding:0.2em 0.3em;
    }

    .btn-1 {
      background-color: #f8ac59;
    }
    .btn-2 {
      background-color: #1ab394;
    }
    .btn-3 {
      background-color: #9bca63;
    }
  }
</style>



// WEBPACK FOOTER //
// map_pre.vue?5f0de3f2